// Tiny, framework-free module split out of OnboardingModal.js so App.js can
// check `hasCompletedOnboarding` synchronously — it gates MainApp's initial
// state (`useState(() => !hasCompletedOnboarding(initialUserId))`) — without
// statically importing the whole onboarding modal component tree. That
// static import was blocking OnboardingModal.js from being code-split out
// of the anonymous/homepage bundle (see App.js's
// `React.lazy(() => import("./components/OnboardingModal"))`).
//
// Versioned, user-keyed so each user gets their own flag.
// Bump the version suffix (v3 → v4) to force the flow to re-show for everyone
// after a significant content change.
const ONBOARDING_KEY_PREFIX = "onboarding-complete-v3";

function getOnboardingKey(userId) {
  return userId
    ? `${ONBOARDING_KEY_PREFIX}-${userId}`
    : ONBOARDING_KEY_PREFIX;
}

export function hasCompletedOnboarding(userId) {
  return localStorage.getItem(getOnboardingKey(userId)) === "true";
}

export function markOnboardingComplete(userId) {
  localStorage.setItem(getOnboardingKey(userId), "true");
}
